var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.writeLayouts),function(writeLayout){return _c('item-write-link',{key:`itemComp${writeLayout}`,attrs:{"writeLayout":writeLayout,"itemCategoryList":_vm.itemCategoryList}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }